module.exports = "/images/inprox.png?6229fa3ee617f702bf441c0de5d8cce3";